import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedServiceService {

  private messageSource = new BehaviorSubject<string>(''); // Default value can be empty
  currentMessage = this.messageSource.asObservable();

  private stageSource = new BehaviorSubject<string>(''); // Default value can be empty
  currentUpdatedStage$ = this.stageSource.asObservable();

  updateMessage(message: string) {
    this.messageSource.next(message); // Push new data to subscribers
  }

  // Update Stage on Summary bar
  updateStage(stageName:string){
    this.stageSource.next(stageName);
  }
}
